import { message } from "antd";
export function  exportTextFile(data: any[], fileName:string) {
    if (data?.length) {
      const headers = `${Object.keys(data[0]).join('|')}`;

      const rows = data?.map((item, index) => {
        const row = `${Object.values(item).join('|')}`;
        return row;
      });
      const textContent = [headers, ...rows].join('\n');
      const blob = new Blob([textContent], { type: 'text/plain' });
  
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${fileName}.txt`;
      a.click();
  
      URL.revokeObjectURL(url);
    } else {
      message.error("No data available for text file generation.");
    }
}
